import React, { useState, useEffect, useMemo, useContext } from 'react';
import Secured from 'Secured';
import { differenceBy } from 'lodash';

import App from 'contexts/App';
import UserContext from 'contexts/UserContext';
import Modal from 'components/Modal';
import Grade from 'containers/Administrator/Users/Create_Old/Student/Grades/Add/Grade';

const Add = Secured(({ request, modal, handleModal }) => {
	// Use app's context
	const { notify } = useContext(App);

	// Use user's context
	const { user } = useContext(UserContext);

	// Store grades
	const [grades, setGrades] = useState([]);

	// Store available grades for selection
	const available = useMemo(() =>
		differenceBy(grades, user.grades, 'id')
	, [grades, user.grades]);

	// Collect grades
	useEffect(() => {
		const parameters = {
			eager: '[program, blanks.courses.[subject, exam]]'
		};

		// If modal is closed, clear stored grades
		if (!modal) return setGrades([]);

		// Collect grades with given parameters
		request('get', 'grades', parameters, null, res => {
			// Update grade's state
			if (!res.error) return setGrades(res);

			// Create notification
			notify('warning', res.error);
		});
	}, [modal, request, notify]);

	return (
		<Modal title="Pievienot klasi" visible={modal} handleModal={handleModal}>
			<div className="studentGrades studentGrades--modal withMarginTop">
				{available.map(grade =>
					<Grade key={grade.id} grade={grade} />
				)}
			</div>
		</Modal>
	);
});

export default Add;